<!--Miga de Pan-->
<section class="miga_pan">
    <div class="cnt_central">
        <div class="miga" [style.color]="colorTxt">
            <div class="cnt_links_miga">
                <a  routerLink="/directo"> home </a>
                <i class="far fa-angle-right"></i>
                <a > Políticas </a>
            </div>
            
        </div>
    </div>
</section>
<!--/end-Miga de Pan-->